export default [
  {
    "value": "1_and_1_hosting",
    "label": "1&1 Hosting"
  },
  {
    "value": "3d_cart",
    "label": "3d Cart"
  },
  {
    "value": "acquisio",
    "label": "Acquisio"
  },
  {
    "value": "activecampaign",
    "label": "Activecampaign"
  },
  {
    "value": "add_to_any",
    "label": "Add To Any"
  },
  {
    "value": "adobe_business_catalyst",
    "label": "Adobe Business Catalyst"
  },
  {
    "value": "adobe_connect",
    "label": "Adobe Connect"
  },
  {
    "value": "adobe_dynamic_tag_management",
    "label": "Adobe Dynamic Tag Management"
  },
  {
    "value": "adroll",
    "label": "AdRoll"
  },
  {
    "value": "airbrake",
    "label": "Airbrake"
  },
  {
    "value": "akamai",
    "label": "Akamai"
  },
  {
    "value": "akamai_dns",
    "label": "Akamai DNS"
  },
  {
    "value": "alexa",
    "label": "Alexa"
  },
  {
    "value": "altocloud",
    "label": "Altocloud"
  },
  {
    "value": "amazon_associates",
    "label": "Amazon Associates"
  },
  {
    "value": "amazon_payments",
    "label": "Amazon Payments"
  },
  {
    "value": "amazon_s3",
    "label": "Amazon S3"
  },
  {
    "value": "amazon_ses",
    "label": "Amazon Simple Email Service"
  },
  {
    "value": "amcharts",
    "label": "amCharts"
  },
  {
    "value": "amplitude",
    "label": "Amplitude"
  },
  {
    "value": "android",
    "label": "Android"
  },
  {
    "value": "apache",
    "label": "Apache"
  },
  {
    "value": "app_nexus",
    "label": "App Nexus"
  },
  {
    "value": "appboy",
    "label": "Appboy"
  },
  {
    "value": "appcues",
    "label": "Appcues"
  },
  {
    "value": "appdynamics",
    "label": "AppDynamics"
  },
  {
    "value": "apteligent",
    "label": "Apteligent"
  },
  {
    "value": "asp_net",
    "label": "ASP.Net"
  },
  {
    "value": "attribution",
    "label": "Attribution"
  },
  {
    "value": "authorizenet",
    "label": "Authorizenet"
  },
  {
    "value": "autopilot",
    "label": "Autopilot"
  },
  {
    "value": "aweber",
    "label": "Aweber"
  },
  {
    "value": "aws_ec2",
    "label": "Amazon Web Services"
  },
  {
    "value": "aws_route_53",
    "label": "Route 53"
  },
  {
    "value": "bazaarvoice",
    "label": "Bazaarvoice"
  },
  {
    "value": "benchmarkemail",
    "label": "Benchmarkemail"
  },
  {
    "value": "big_cartel",
    "label": "Big Cartel"
  },
  {
    "value": "bigcommerce",
    "label": "Bigcommerce"
  },
  {
    "value": "bing_ads",
    "label": "Bing Ads"
  },
  {
    "value": "bing_advertiser",
    "label": "Bing Advertiser"
  },
  {
    "value": "bing_maps",
    "label": "Bing Maps"
  },
  {
    "value": "bloomreach",
    "label": "Bloomreach"
  },
  {
    "value": "bluehost_hosting",
    "label": "Bluehost Hosting"
  },
  {
    "value": "braintree",
    "label": "Braintree"
  },
  {
    "value": "branch",
    "label": "Branch"
  },
  {
    "value": "brightcove",
    "label": "Brightcove"
  },
  {
    "value": "bronto",
    "label": "Bronto"
  },
  {
    "value": "bug_herd",
    "label": "Bug Herd"
  },
  {
    "value": "bugsnag",
    "label": "Bugsnag"
  },
  {
    "value": "calq",
    "label": "Calq"
  },
  {
    "value": "campaignmonitor",
    "label": "Campaignmonitor"
  },
  {
    "value": "castle",
    "label": "Castle"
  },
  {
    "value": "centos",
    "label": "CentOS"
  },
  {
    "value": "chargify",
    "label": "Chargify"
  },
  {
    "value": "chart_beat",
    "label": "Chart Beat"
  },
  {
    "value": "chartio",
    "label": "Chartio"
  },
  {
    "value": "chatlio",
    "label": "Chatlio"
  },
  {
    "value": "chownow",
    "label": "Chownow"
  },
  {
    "value": "clickfunnels",
    "label": "ClickFunnels"
  },
  {
    "value": "clicktale",
    "label": "Clicktale"
  },
  {
    "value": "clicky",
    "label": "Clicky"
  },
  {
    "value": "cloud_flare",
    "label": "Cloud Flare"
  },
  {
    "value": "cloudinary",
    "label": "Cloudinary"
  },
  {
    "value": "commerce_sciences",
    "label": "Commerce Sciences"
  },
  {
    "value": "constant_contact",
    "label": "Constant Contact"
  },
  {
    "value": "contently",
    "label": "Contently"
  },
  {
    "value": "convert_kit",
    "label": "Convert Kit"
  },
  {
    "value": "crazy_egg",
    "label": "Crazy Egg"
  },
  {
    "value": "criteo",
    "label": "Criteo"
  },
  {
    "value": "customer_io",
    "label": "Customer.io"
  },
  {
    "value": "debian",
    "label": "Debian"
  },
  {
    "value": "demandbase",
    "label": "Demandbase"
  },
  {
    "value": "demandware",
    "label": "Demandware"
  },
  {
    "value": "digital_ocean",
    "label": "Digital Ocean"
  },
  {
    "value": "disqus",
    "label": "Disqus"
  },
  {
    "value": "django",
    "label": "Django"
  },
  {
    "value": "dns_made_easy",
    "label": "DNS Made Easy"
  },
  {
    "value": "double_click",
    "label": "DoubleClick Ads"
  },
  {
    "value": "double_click_advertiser",
    "label": "DoubleClick Advertiser"
  },
  {
    "value": "dreamhost_hosting",
    "label": "DreamHost Hosting"
  },
  {
    "value": "drift",
    "label": "Drift"
  },
  {
    "value": "drip",
    "label": "Drip"
  },
  {
    "value": "drupal",
    "label": "Drupal"
  },
  {
    "value": "dwolla",
    "label": "Dwolla"
  },
  {
    "value": "dyn_dns",
    "label": "Dyn DNS"
  },
  {
    "value": "dynamic_yield",
    "label": "Dynamic Yield"
  },
  {
    "value": "ecwid",
    "label": "Ecwid"
  },
  {
    "value": "elasticemail",
    "label": "ElasticEmail"
  },
  {
    "value": "elevio",
    "label": "Elevio"
  },
  {
    "value": "eloqua",
    "label": "Eloqua"
  },
  {
    "value": "emma",
    "label": "Emma"
  },
  {
    "value": "errorception",
    "label": "Errorception"
  },
  {
    "value": "express",
    "label": "Express"
  },
  {
    "value": "facebook_advertiser",
    "label": "Facebook Advertiser"
  },
  {
    "value": "facebook_beacon",
    "label": "Facebook Beacon"
  },
  {
    "value": "facebook_comments",
    "label": "Facebook Comments"
  },
  {
    "value": "facebook_connect",
    "label": "Facebook Connect"
  },
  {
    "value": "facebook_like_button",
    "label": "Facebook Like Button"
  },
  {
    "value": "facebook_social_plugins",
    "label": "Facebook Social Plugins"
  },
  {
    "value": "fedora",
    "label": "Fedora"
  },
  {
    "value": "formstack",
    "label": "Formstack"
  },
  {
    "value": "freebsd",
    "label": "FreeBSD"
  },
  {
    "value": "freshdesk",
    "label": "Freshdesk"
  },
  {
    "value": "fullcontact",
    "label": "Fullcontact"
  },
  {
    "value": "fullstory",
    "label": "Fullstory"
  },
  {
    "value": "fusioncharts",
    "label": "FusionCharts"
  },
  {
    "value": "gauges",
    "label": "Gauges"
  },
  {
    "value": "get_response",
    "label": "Get Response"
  },
  {
    "value": "get_satisfaction",
    "label": "Get Satisfaction"
  },
  {
    "value": "go_squared",
    "label": "Go Squared"
  },
  {
    "value": "gocardless",
    "label": "Gocardless"
  },
  {
    "value": "godaddy_hosting",
    "label": "GoDaddy Hosting"
  },
  {
    "value": "godaddy_nameserver",
    "label": "Godaddy Nameserver"
  },
  {
    "value": "google_adsense",
    "label": "Google Adsense"
  },
  {
    "value": "google_adwords",
    "label": "Google Adwords"
  },
  {
    "value": "google_affiliate_network",
    "label": "Google Affiliate Network"
  },
  {
    "value": "google_analytics",
    "label": "Google Analytics"
  },
  {
    "value": "google_apps",
    "label": "Google Apps"
  },
  {
    "value": "google_charts",
    "label": "Google Charts"
  },
  {
    "value": "google_cloud",
    "label": "Google Cloud"
  },
  {
    "value": "google_forms",
    "label": "Google Forms"
  },
  {
    "value": "google_maps",
    "label": "Google Maps"
  },
  {
    "value": "google_tag_manager",
    "label": "Google Tag Manager"
  },
  {
    "value": "google_website_optimizer",
    "label": "Google Website Optimizer"
  },
  {
    "value": "google_widgets",
    "label": "Google Widgets"
  },
  {
    "value": "graphiq",
    "label": "GraphIQ"
  },
  {
    "value": "gravity_forms",
    "label": "Gravity Forms"
  },
  {
    "value": "greenhouse",
    "label": "Greenhouse"
  },
  {
    "value": "heap",
    "label": "Heap"
  },
  {
    "value": "hello_bar",
    "label": "Hello Bar"
  },
  {
    "value": "help_scout",
    "label": "Help Scout"
  },
  {
    "value": "heroku",
    "label": "Heroku"
  },
  {
    "value": "highcharts",
    "label": "Highcharts"
  },
  {
    "value": "hotjar",
    "label": "Hotjar"
  },
  {
    "value": "hoverowl",
    "label": "Hoverowl"
  },
  {
    "value": "hubspot",
    "label": "HubSpot"
  },
  {
    "value": "icims",
    "label": "Icims"
  },
  {
    "value": "indicative",
    "label": "Indicative"
  },
  {
    "value": "infusionsoft",
    "label": "Infusionsoft"
  },
  {
    "value": "inside_sales",
    "label": "Inside Sales"
  },
  {
    "value": "inspectlet",
    "label": "Inspectlet"
  },
  {
    "value": "instagram",
    "label": "Instagram"
  },
  {
    "value": "instagram_links",
    "label": "Instagram Links"
  },
  {
    "value": "instart_logic",
    "label": "Instart Logic"
  },
  {
    "value": "intense_debate",
    "label": "Intense Debate"
  },
  {
    "value": "intercom",
    "label": "Intercom"
  },
  {
    "value": "ios",
    "label": "ios"
  },
  {
    "value": "iterable",
    "label": "Iterable"
  },
  {
    "value": "java",
    "label": "Java"
  },
  {
    "value": "jobvite",
    "label": "Jobvite"
  },
  {
    "value": "joomla",
    "label": "Joomla"
  },
  {
    "value": "kapost",
    "label": "Kapost"
  },
  {
    "value": "keen_io",
    "label": "Keen IO"
  },
  {
    "value": "kiss_metrics",
    "label": "Kissmetrics"
  },
  {
    "value": "klaviyo",
    "label": "Klaviyo"
  },
  {
    "value": "knowtify",
    "label": "Knowtify"
  },
  {
    "value": "lead_dyno",
    "label": "Lead Dyno"
  },
  {
    "value": "lever",
    "label": "Lever"
  },
  {
    "value": "linked_in_advertiser",
    "label": "LinkedIn Advertiser"
  },
  {
    "value": "linkwithin",
    "label": "Linkwithin"
  },
  {
    "value": "linode_hosting",
    "label": "Linode Hosting"
  },
  {
    "value": "live_chat",
    "label": "Live Chat"
  },
  {
    "value": "livefyre",
    "label": "Livefyre"
  },
  {
    "value": "liveramp",
    "label": "Liveramp"
  },
  {
    "value": "localytics",
    "label": "Localytics"
  },
  {
    "value": "looker",
    "label": "Looker"
  },
  {
    "value": "lucky_orange",
    "label": "Lucky Orange"
  },
  {
    "value": "mad_kudu",
    "label": "Mad Kudu"
  },
  {
    "value": "magento",
    "label": "Magento"
  },
  {
    "value": "magento_enterprise",
    "label": "Magento Enterprise"
  },
  {
    "value": "mailchimp",
    "label": "Mailchimp"
  },
  {
    "value": "mailgun",
    "label": "Mailgun"
  },
  {
    "value": "mailjet",
    "label": "Mailjet"
  },
  {
    "value": "mandrill",
    "label": "Mandrill"
  },
  {
    "value": "marketo",
    "label": "Marketo"
  },
  {
    "value": "maxmind",
    "label": "Maxmind"
  },
  {
    "value": "microsoft_azure",
    "label": "Microsoft Azure"
  },
  {
    "value": "microsoft_exchange_online",
    "label": "Microsoft Exchange Online"
  },
  {
    "value": "microsoft_office_365",
    "label": "Microsoft Office 365"
  },
  {
    "value": "mixpanel",
    "label": "Mixpanel"
  },
  {
    "value": "mode",
    "label": "Mode"
  },
  {
    "value": "mouseflow",
    "label": "Mouseflow"
  },
  {
    "value": "mousestats",
    "label": "Mousestats"
  },
  {
    "value": "my_site_auditor",
    "label": "My Site Auditor"
  },
  {
    "value": "namecheap_dns",
    "label": "Namecheap Dns"
  },
  {
    "value": "new_relic",
    "label": "New Relic"
  },
  {
    "value": "nextable",
    "label": "Nextable"
  },
  {
    "value": "nginx",
    "label": "Nginx"
  },
  {
    "value": "nosto",
    "label": "Nosto"
  },
  {
    "value": "olark",
    "label": "Olark"
  },
  {
    "value": "omniconvert",
    "label": "Omniconvert"
  },
  {
    "value": "omniture_adobe_analytics",
    "label": "Omniture (Adobe Analytics)"
  },
  {
    "value": "ooyala",
    "label": "Ooyala"
  },
  {
    "value": "open_table",
    "label": "Open Table"
  },
  {
    "value": "optimizely",
    "label": "Optimizely"
  },
  {
    "value": "optimonk",
    "label": "Optimonk"
  },
  {
    "value": "oscommerce",
    "label": "Oscommerce"
  },
  {
    "value": "outbound",
    "label": "Outbound"
  },
  {
    "value": "outbrain_ads",
    "label": "Outbrain Ads"
  },
  {
    "value": "outlook",
    "label": "Outlook"
  },
  {
    "value": "owneriq",
    "label": "ownerIQ"
  },
  {
    "value": "pardot",
    "label": "Pardot"
  },
  {
    "value": "paypal",
    "label": "PayPal"
  },
  {
    "value": "payza",
    "label": "Payza"
  },
  {
    "value": "percolate",
    "label": "Percolate"
  },
  {
    "value": "perfect_audience",
    "label": "Perfect Audience"
  },
  {
    "value": "periscope_data",
    "label": "Periscope Data"
  },
  {
    "value": "pinterest",
    "label": "Pinterest"
  },
  {
    "value": "piwik",
    "label": "Piwik"
  },
  {
    "value": "postmark",
    "label": "Postmark"
  },
  {
    "value": "powerreviews",
    "label": "PowerReviews"
  },
  {
    "value": "qualaroo",
    "label": "Qualaroo"
  },
  {
    "value": "qualtrics",
    "label": "Qualtrics"
  },
  {
    "value": "quantcast",
    "label": "Quantcast"
  },
  {
    "value": "qubit",
    "label": "Qubit"
  },
  {
    "value": "rackspace",
    "label": "Rackspace"
  },
  {
    "value": "rackspace_email",
    "label": "Rackspace Email"
  },
  {
    "value": "recaptcha",
    "label": "Recaptcha"
  },
  {
    "value": "recruiterbox",
    "label": "Recruiterbox"
  },
  {
    "value": "recurly",
    "label": "Recurly"
  },
  {
    "value": "red_hat",
    "label": "Red Hat"
  },
  {
    "value": "resrcit",
    "label": "ReSRCit"
  },
  {
    "value": "resumator",
    "label": "Resumator"
  },
  {
    "value": "retailrocket",
    "label": "RetailRocket"
  },
  {
    "value": "rezdy",
    "label": "Rezdy"
  },
  {
    "value": "rezgo",
    "label": "Rezgo"
  },
  {
    "value": "robly",
    "label": "Robly"
  },
  {
    "value": "rollbar",
    "label": "Rollbar"
  },
  {
    "value": "ruby_on_rails",
    "label": "Ruby On Rails"
  },
  {
    "value": "salesforce",
    "label": "Salesforce"
  },
  {
    "value": "salesmachine",
    "label": "Salesmachine"
  },
  {
    "value": "satismeter",
    "label": "Satismeter"
  },
  {
    "value": "segment",
    "label": "Segment"
  },
  {
    "value": "sendgrid",
    "label": "Sendgrid"
  },
  {
    "value": "sentry",
    "label": "Sentry"
  },
  {
    "value": "sessioncam",
    "label": "Sessioncam"
  },
  {
    "value": "sharepoint",
    "label": "Sharepoint"
  },
  {
    "value": "shopify",
    "label": "Shopify"
  },
  {
    "value": "shopify_plus",
    "label": "Shopify Plus"
  },
  {
    "value": "shopware",
    "label": "Shopware"
  },
  {
    "value": "silkroad",
    "label": "Silkroad"
  },
  {
    "value": "simplicant",
    "label": "Simplicant"
  },
  {
    "value": "slack",
    "label": "Slack"
  },
  {
    "value": "smartlook",
    "label": "Smartlook"
  },
  {
    "value": "socket_io",
    "label": "Socket.io"
  },
  {
    "value": "softlayer_hosting",
    "label": "Softlayer Hosting"
  },
  {
    "value": "squarespace",
    "label": "Squarespace"
  },
  {
    "value": "steel_house",
    "label": "SteelHouse"
  },
  {
    "value": "stripe",
    "label": "Stripe"
  },
  {
    "value": "success_factors",
    "label": "Success Factors"
  },
  {
    "value": "survey_monkey",
    "label": "Survey Monkey"
  },
  {
    "value": "tableau",
    "label": "Tableau"
  },
  {
    "value": "taboola_ads",
    "label": "Taboola Ads"
  },
  {
    "value": "taleo",
    "label": "Taleo"
  },
  {
    "value": "talkable",
    "label": "Talkable"
  },
  {
    "value": "tawk",
    "label": "Tawk"
  },
  {
    "value": "tealium",
    "label": "Tealium"
  },
  {
    "value": "totango",
    "label": "Totango"
  },
  {
    "value": "tout",
    "label": "Tout"
  },
  {
    "value": "toutapp",
    "label": "Toutapp"
  },
  {
    "value": "towerdata",
    "label": "TowerData"
  },
  {
    "value": "track_js",
    "label": "Track JS"
  },
  {
    "value": "trustpilot",
    "label": "Trustpilot"
  },
  {
    "value": "twitter_advertiser",
    "label": "Twitter Advertiser"
  },
  {
    "value": "twitter_badge",
    "label": "Twitter Badge"
  },
  {
    "value": "twitter_button",
    "label": "Twitter Button"
  },
  {
    "value": "typeform",
    "label": "Typeform"
  },
  {
    "value": "typekit_by_adobe",
    "label": "Typekit By Adobe"
  },
  {
    "value": "uber_cart",
    "label": "Uber Cart"
  },
  {
    "value": "ubuntu",
    "label": "Ubuntu"
  },
  {
    "value": "ultipro",
    "label": "Ultipro"
  },
  {
    "value": "unix",
    "label": "Unix"
  },
  {
    "value": "user_voice",
    "label": "UserVoice"
  },
  {
    "value": "vero",
    "label": "Vero"
  },
  {
    "value": "verticalresponse",
    "label": "Verticalresponse"
  },
  {
    "value": "videojs",
    "label": "Video.js"
  },
  {
    "value": "vidyard",
    "label": "Vidyard"
  },
  {
    "value": "vimeo",
    "label": "Vimeo"
  },
  {
    "value": "virtue_mart",
    "label": "Virtue Mart"
  },
  {
    "value": "visual_website_optimizer",
    "label": "Visual Website Optimizer"
  },
  {
    "value": "volusion",
    "label": "Volusion"
  },
  {
    "value": "webengage",
    "label": "WebEngage"
  },
  {
    "value": "weebly",
    "label": "Weebly"
  },
  {
    "value": "wistia",
    "label": "Wistia"
  },
  {
    "value": "wix_stores",
    "label": "Wix Stores"
  },
  {
    "value": "woo_commerce",
    "label": "Woo Commerce"
  },
  {
    "value": "woopra",
    "label": "Woopra"
  },
  {
    "value": "wootric",
    "label": "Wootric"
  },
  {
    "value": "wordpress",
    "label": "Wordpress"
  },
  {
    "value": "workable",
    "label": "Workable"
  },
  {
    "value": "wp_engine",
    "label": "Wp Engine"
  },
  {
    "value": "wufoo",
    "label": "Wufoo"
  },
  {
    "value": "xt_commerce",
    "label": "xt:Commerce"
  },
  {
    "value": "yahoo_stores",
    "label": "Yahoo Stores"
  },
  {
    "value": "yandex_metrica",
    "label": "Yandex Metrica"
  },
  {
    "value": "yelp_seatme",
    "label": "Yelp Seatme"
  },
  {
    "value": "yesware",
    "label": "Yesware"
  },
  {
    "value": "yieldify",
    "label": "Yieldify"
  },
  {
    "value": "yotpo",
    "label": "Yotpo"
  },
  {
    "value": "youtube",
    "label": "Youtube"
  },
  {
    "value": "zen_cart",
    "label": "Zen Cart"
  },
  {
    "value": "zendesk",
    "label": "Zendesk"
  },
  {
    "value": "zenreach",
    "label": "Zenreach"
  },
  {
    "value": "zopim",
    "label": "Zopim"
  },
  {
    "value": "zuora",
    "label": "Zuora"
  }
]



// WEBPACK FOOTER //
// ./src/scripts/constants/ClearbitTech.js